
<div class="colors">
  <div
    v-if="swatchVisible"
    class="color-swatch py-3 d-flex flex-wrap mx-auto"
  >
    <div
      class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
      @click.stop.prevent="addNewColorShowPicker"
    >
      <i class="material-icons">add</i>
       <small>{{ $t("elements.properties.color.add") }}</small>
    </div>

    <div
      v-if="usage !== 'SapSiteSettings'"
      class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
      @click.stop.prevent="applyColorsAll({colorId: null, toBg: toBg})"
    >
      <i class="material-icons">format_color_reset</i>
       <small>{{ $t("elements.properties.color.clear") }}</small>
    </div>

    <div 
      v-for="(color, key) in colors"
      :key="key"
      class="theme-color theme-color--editable"
      :style="colorToStyle(color)"
      @click.stop="applyColorsAll({colorId: key, toBg: toBg})"
    >
      <div
        class="theme-color__edit__btn"
        @click.stop="enableColorPicker(color, key)"
      >
        {{ $t("editor.right_nav.theme.color_picker.edit.btn") }}
      </div>
    </div>
  </div>
  <div
    v-else-if="colorPickerVisible"
    class="color-picker"
  >
    <div class="row no-gutters">
      <div class="col-auto">
        <color-picker
          ref="picker"
          @change="updateCurrentColor"
        />
      </div>
    </div>

    <div v-if="usage === ''" class="divider" />

    <div 
      v-if="usage === ''"
      class="row no-gutters"
    >
      <div class="col">
        <button
          class="btn btn-success btn-block"
          @click.prevent.stop="disableColorPicker"
        >
          {{ $t("editor.right_nav.theme.color_picker.save.btn") }}
        </button>
      </div>
      <div class="col-auto mx-1" />
      <div class="col">
        <button
          class="btn btn-danger btn-block"
          @click.prevent.stop="removeColorPrompt"
        >
          {{ $t("editor.right_nav.theme.color_picker.delete.btn") }}
        </button>
      </div>
    </div>

    <div 
      v-if="usage === 'SapSiteSettings'"
      class="row no-gutters"
    >
      <div class="col">
        <button
          class="btn btn-success site-settings-btns"
          @click.prevent.stop="disableColorPicker"
        >
          {{ $t("editor.right_nav.theme.color_picker.save.btn") }}
        </button>

         <button
          class="btn btn-danger site-settings-btns"
          @click.prevent.stop="removeColorPrompt"
        >
          {{ $t("editor.right_nav.theme.color_picker.delete.btn") }}
        </button>
      </div>
    </div>

  </div>

  <div
    v-if="alpha && swatchVisible"
    class="row"
  >
    <div class="col-auto d-flex align-items-center">
      <h6 :class="textColorClass">{{ $t("elements.properties.color.transparency") }}</h6>
    </div>
    <div class="col">
      <cvt-slider
        id="slider-default"
        :tooltips-enabled="true"
        :step-marks-enabled="true"
        class="slider"
        :min="0"
        :max="1"
        :value="transparencyVal"
        :step="0.1"
        @change="onChange"
      />
    </div>
  </div>

</div>
